import { useState } from "react";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import Calling from "../../api/Calling";
import { useNavigate } from "react-router-dom";
import { FaLock, FaUserShield } from "react-icons/fa";

export default function Login({ onLogin }) {
  const [loader, setLoader] = useState(false);
  const [adminId, setAdminId] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);

    const body = {
      a_email: adminId,
      a_password: password,
    };

    try {
      const resp = await Calling.AdminLogin(body);
      const { status, token, message } = resp;

      if (status) {
        toast.success(message || "Login Successful!", { autoClose: 2000 });
        localStorage.setItem("admin_cashyapp", token);
        onLogin(true);
        navigate("/");
      } else {
        toast.error(message || "Invalid credentials.", { autoClose: 2000 });
        setLoader(false);
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong!", { autoClose: 2000 });
      setLoader(false);
    }
  };

  return (
    <>
      {loader && <Loader />}

      <div className="min-h-screen w-full flex items-center justify-center px-4 py-6 bg-gradient-to-br from-main-blue/40 to-blue-300/30 relative overflow-hidden">
        {/* Decorative gradient blobs */}
        <div className="absolute top-10 left-10 w-40 h-40 bg-main-blue/30 rounded-full blur-3xl" />
        <div className="absolute bottom-10 right-10 w-56 h-56 bg-blue-400/30 rounded-full blur-3xl" />

        <div className="relative bg-white/60 backdrop-blur-2xl border border-white/30 shadow-2xl p-8 md:p-10 rounded-3xl w-full max-w-md">
          <div className="flex flex-col items-center text-center">
            <div className="bg-main-blue text-white p-4 rounded-2xl shadow-lg mb-4">
              <FaUserShield className="text-3xl" />
            </div>
            <h1 className="text-2xl md:text-3xl font-extrabold text-main-font tracking-tight mb-2">
              Cashy App Admin
            </h1>

            <p className="text-sm text-gray-600 mb-6">
              Please sign in to continue
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            {/* Email Input */}
            <div className="relative">
              <FaUserShield className="absolute left-3 top-1/2 transform -translate-y-1/2 text-main-blue/70" />
              <input
                type="email"
                value={adminId}
                onChange={(e) => setAdminId(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border border-main-border rounded-xl text-sm md:text-base focus:ring-2 focus:ring-main-blue outline-none placeholder-gray-400 bg-white/70"
                placeholder="Enter admin email"
                required
              />
            </div>

            {/* Password Input */}
            <div className="relative">
              <FaLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-main-blue/70" />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border border-main-border rounded-xl text-sm md:text-base focus:ring-2 focus:ring-main-blue outline-none placeholder-gray-400 bg-white/70"
                placeholder="Enter password"
                required
              />
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={loader}
              className="w-full bg-gradient-to-r from-main-blue to-blue-500 text-white py-3 rounded-xl font-semibold text-base shadow-md hover:shadow-lg hover:scale-[1.01] transition-transform"
            >
              {loader ? "Signing in..." : "Login"}
            </button>
          </form>

          <p className="text-xs text-gray-500 text-center mt-6">
            © {new Date().getFullYear()} Admin Control Panel. All rights
            reserved.
          </p>
        </div>
      </div>
    </>
  );
}
